export class Config {
	public static readonly LOCAL_STORAGE_SETTINGS = 'debatt.settings';
}
